export const TRIAL_FREE_TYPE = 'trial';
export const BONUS_FREE_TYPE = 'bonus';
